/** Saved coordinates on the account, or null while they are still the 0,0 placeholder. */
export const savedBuyerPoint = (user) => {
  const loc = user?.location;
  return loc && Number(loc.lat) && Number(loc.lon) ? { lat: Number(loc.lat), lon: Number(loc.lon) } : null;
};

/** Singleton geolocation: request once and cache for every caller */
let geoPromise = null;
let geoResult = null;
export const getBrowserLocation = () => {
  if (geoResult) return Promise.resolve(geoResult);
  if (geoPromise) return geoPromise;
  if (!navigator.geolocation) return Promise.resolve(null);
  geoPromise = new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        geoResult = { lat: pos.coords.latitude, lon: pos.coords.longitude };
        resolve(geoResult);
      },
      () => resolve(null),
      { timeout: 5000, maximumAge: 600000 }
    );
  });
  return geoPromise;
};
